import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ resource, manager }) =>
    present(
      repository
        .unAssignManagerFromResource(resource, manager)
        .then(() => ({ resource, manager }))
        .catch(() => Promise.reject({ resource })),
    );
}

export type { Interactor };

export { createInteractor };
